<template>
    <main
        class="main"
        :style="{
            backgroundImage: bgUrl ? 'url(' + bgUrl + ')' : '',
            backgroundRepeat: bgUrl ? 'no-repeat' : 'repeat-x',
            backgroundSize: bgUrl ? '10rem' : ''
        }"
    >
        <!-- <img class="bg-icons" src="../assets/images/bg-icons.png" alt="" /> -->
        <div class="mask" v-if="configFailHint">
            <div class="modal">
                <div class="title">
                    <h3 class="tip">提示</h3>
                    <img @click="handleCloseModal" src="../assets/images/close.png" alt="" />
                </div>
                <div class="content">
                    {{ configFailHint }}
                </div>
                <div class="bottom">
                    <div class="btn left" @click="handleCloseModal">关闭</div>
                    <!-- <div class="btn right" @click="handleShareFriend">分享朋友</div> -->
                </div>
            </div>
        </div>
    </main>
</template>
<script>
import { mapState } from 'vuex';
// import { nShare, closeWebView } from '@eastmoney/utils';
import { nShare, closeWebView } from '@eastmoney/mku';
import browser from '@/libs/browser';
import { CHANGE_QUESTIONNAIRE_CODE } from '@/libs/constant';

export default {
    name: 'fail',
    data() {
        return {};
    },
    computed: {
        ...mapState(['configFailHint', 'pictureConfig']),
        bgUrl() {
            return this.pictureConfig.h5Bg;
        }
    },
    methods: {
        handleCloseModal() {
            if (browser.isApp()) {
                closeWebView();
            }
            this.$store.commit('setConfigFailHint', '');
        },
        handleShareFriend() {
            const { shareInfo } = this.$store.state;
            if (browser.isApp()) {
                nShare({
                    ...shareInfo
                });
            } else {
                this.$wxShare.shareTo('wechat');
            }
        },
        initQuestionnaire() {
            const { code } = this.$route.query;
            if (code) {
                this.$store.commit(CHANGE_QUESTIONNAIRE_CODE, code);
                this.$store.dispatch('getQuestionConfig', code);
                this.$trackLaunch(code);
            } else {
                this.$toast('当前页面地址不存在问卷代码');
            }
        }
    },
    mounted() {
        this.initQuestionnaire();
    }
};
</script>
<style lang="scss" scoped>
.main {
    width: 750px;
    margin: 0 auto;
    // background-image: linear-gradient(180deg, #f87a3b 0%, #f97c3c 66%, #ffffff 100%);
    background-image: url('../assets/images/bg-jianbian.png');
    background-repeat: repeat-x;
    background-attachment: fixed;
    background-size: 100% 720px;
    min-height: 100vh;
    overflow: hidden;
    position: relative;
    background-color: #fff;
    .bg-icons {
        position: absolute;
        top: 0;
        left: 0;
        width: 750px;
    }
    .mask {
        position: absolute;
        top: 0;
        left: 0;
        width: 750px;
        height: 100%;
        background: rgba($color: #000000, $alpha: 0.7);
        z-index: 1000;
        display: flex;
        justify-content: center;
        align-items: center;
        .modal {
            width: 654px;
            background: #fff;
            position: relative;
            border-radius: 24px;
            .title {
                padding: 40px 0;
                .tip {
                    text-align: center;
                    font-size: 36px;
                    color: #333;
                }
                img {
                    float: right;
                    position: absolute;
                    top: 43px;
                    right: 40px;
                    width: 48px;
                }
            }
            .content {
                font-size: 28px;
                line-height: 1.4;
                color: #333333;
                padding: 0 48px 40px 48px;
            }
        }
        .bottom {
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 0 0 48px 0;
            .btn {
                font-size: 30px;
                padding: 20px 0;
                width: 262px;
                border-radius: 16px;
                text-align: center;
            }
            .left {
                border: 2px solid #f0f0f0;
                color: #000000;
                margin-right: 30px;
                font-weight: 700;
            }
            .right {
                border: 2px solid #933709;
                background-color: #ff6b20;
                color: #fff;
            }
        }
    }
}
</style>
